import { System, Entity, Velocity } from '@badideagames/engine';
import { Gravity } from '../components/Gravity';

export class GravitySystem extends System {
  requiredComponents = [Velocity, Gravity];

  update(entities: Entity[], delta: number): void {
    for (const entity of entities) {
      const velocity = entity.get(Velocity);
      const gravity = entity.get(Gravity);
      velocity.vy += gravity.force * delta;
    }
  }
}
